/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { Placement } from '@popperjs/core'
import { Tooltip } from '@positivote/design-system/components/Tooltip'
import { useTheme } from '@positivote/design-system/hooks'
import { AlertIcon } from '@positivote/design-system/icons/Alert'
import { AlertErrorIcon } from '@positivote/design-system/icons/AlertError'
import { CheckCircleIcon } from '@positivote/design-system/icons/CheckCircle'
import { Breakpoint } from '@positivote/design-system/theme'
import { browserName, browserVersion, fullBrowserVersion } from 'react-device-detect'

import { i18n } from '@/common/i18n'

import { AccordionRequirements } from './AccordionRequirements'

export interface AccordionBrowserProps {
  browser:
    | {
        name: string
        minimumVersion: number
        warningMsg: string
        erroMsg: string
        recommendedBrowsers: boolean
      }
    | undefined
  isLoading: boolean
}

export function AccordionBrowser({ browser, isLoading }: AccordionBrowserProps): JSX.Element {
  const { breakpoint } = useTheme()

  const tooltipPlacement: Placement = breakpoint >= Breakpoint.lg ? 'right' : 'left'

  return (
    <AccordionRequirements
      requirementsProps={{
        title: i18n().modules.requirements.components.accordionBrowser.title,
        descriptions: [
          {
            key: 'browser',
            label: i18n().modules.requirements.components.accordionBrowser.type,
            value:
              browserName === 'none'
                ? i18n().modules.requirements.pages.details.errorMessage
                : browserName,
            icon:
              browserName === 'none' ? (
                <Tooltip
                  label={
                    i18n().modules.requirements.components.accordionBrowser.tooltip
                      .incompatibleBrowserMessage
                  }
                  placement={tooltipPlacement}
                  arrow
                >
                  <AlertErrorIcon fill="$critical" />
                </Tooltip>
              ) : browser?.recommendedBrowsers ? (
                <CheckCircleIcon fill="$success" />
              ) : (
                <Tooltip
                  label={
                    browser?.erroMsg ??
                    i18n().modules.requirements.components.accordionBrowser.tooltip
                      .incompatibleBrowserMessage
                  }
                  placement={tooltipPlacement}
                  arrow
                >
                  <AlertErrorIcon fill="$critical" />
                </Tooltip>
              )
          },
          {
            key: 'browserVersion',
            label: i18n().modules.requirements.components.accordionBrowser.version,
            value:
              browserVersion === 'none'
                ? i18n().modules.requirements.pages.details.errorMessage
                : fullBrowserVersion,
            icon:
              browserVersion === 'none' ? (
                <Tooltip
                  label={
                    i18n().modules.requirements.components.accordionBrowser.tooltip
                      .incompatibleBrowserVersionMessage
                  }
                  placement={tooltipPlacement}
                  arrow
                >
                  <AlertErrorIcon fill="$critical" />
                </Tooltip>
              ) : Number(browserVersion) >= Number(browser?.minimumVersion) ? (
                <CheckCircleIcon fill="$success" />
              ) : (
                <Tooltip
                  label={
                    browser?.warningMsg ??
                    i18n().modules.requirements.components.accordionBrowser.tooltip
                      .incompatibleBrowserVersionMessage
                  }
                  placement={tooltipPlacement}
                  arrow
                >
                  <AlertIcon fill="$warning" />
                </Tooltip>
              )
          }
        ]
      }}
      isLoading={isLoading}
    />
  )
}
